<template>
  <!-- wms导购登录 -->
  <div class="content">
    <div class="form-box">
      <div class="title">登录账号</div>
      <input type="number"
             v-model="phone"
             placeholder="请输入手机号">
      <div class="pwd-box">
        <input :type="inputType"
               v-model="password"
               placeholder="请输入密码">
        <img class="pwd-btn"
             v-if="showPwd"
             @click="onchangeType('password')"
             src="../../../public/images/wms/show-pwd.png"
             alt="">
        <img class="pwd-btn"
             v-if="!showPwd"
             @click="onchangeType('text')"
             src="../../../public/images/wms/hide-pwd.png"
             alt="">
      </div>
      <button @click="login">登 录</button>
      <div class="forget"
           @click="gotoRest">
        忘记密码？
      </div>
    </div>
  </div>
</template>
<script>
import { salesUserLogin } from '@/api/wmsGuide'
export default {
  data () {
    return {
      phone: '',
      password: '',
      showPwd: false,
      inputType: 'password'
    }
  },
  methods: {
    //登录
    login () {
      if (!this.phone) {
        this.$toast('请输入手机号')
        return
      } else if (!this.password) {
        this.$toast('请输入密码')
        return
      }
      let data = {
        phone: this.phone,
        password: this.password,
      }
      this.$toast.loading({
        duration: 0,
        message: '登录中...',
        forbidClick: true,
      });
      salesUserLogin(data).then(res => {
        this.$toast.clear();
        if (res.code === 200) {
          this.$store.commit("set_wmsUserId", res.data.id)
          if (res.data.salt) {//非第一次登录
            this.$router.push({
              path: '/InvitationCodeList'
            });
          } else {//第一次登录，修改密码
            this.$router.push({
              path: '/reset', query: {
                id: res.data.id,
                phone: res.data.phone
              }
            });
          }
        } else {
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.$toast('网络错误！')
      })
    },

    // 跳转忘记密码
    gotoRest () {
      this.$router.push({
        path: '/reset'
      });
    },

    // 隐藏查看密码
    onchangeType (type) {
      this.showPwd = !this.showPwd
      this.inputType = type
    },
  }
}
</script>
<style lang="scss" scoped>
button {
  padding: 0px;
  margin: 0px;
  border: none;
  background: none;
  font-weight: normal;
}

button::after {
  border: none;
}

input {
  background: none;
  outline: none;
  border: none;
  font-weight: normal;
}

input:focus {
  border: none;
}

input::-webkit-input-placeholder {
  color: #999;
  font-weight: normal;
  font-size: 20px;
}

input::-moz-placeholder {
  color: #999;
  font-weight: normal;
  font-size: 20px;
}

input:-ms-input-placeholder {
  color: #999;
  font-weight: normal;
  font-size: 20px;
}

input::-webkit-input-placeholder {
  color: #999;
  font-weight: normal;
  font-size: 20px;
}

input::placeholder {
  color: #999;
  font-weight: normal;
  font-size: 20px;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: normal;
}
.form-box {
  margin: 0 20px;
  .title {
    margin-bottom: 16px;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
  }
  .pwd-box {
    position: relative;
    .pwd-btn {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(-50%, -50%);
      width: 24px;
      height: 24px;
    }
  }

  input {
    display: block;
    padding: 20px;
    margin-bottom: 12px;
    width: 100%;
    height: 65px;
    background: #f6f6f6;
    border-radius: 4px;
    font-size: 20px;
    color: #000000;
    box-sizing: border-box;
    font-weight: normal;
  }

  button {
    margin-top: 55px;
    width: 100%;
    height: 57px;
    line-height: 57px;
    background: #3472fd;
    border-radius: 4px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
  }
  .forget {
    margin-top: 20px;
    text-align: right;
    font-size: 14px;
    color: #004efe;
    line-height: 22px;
  }
}

.van-field {
  display: block;
  padding: 20px;
  margin-bottom: 12px;
  width: 100%;
  height: 65px;
  background: #f6f6f6;
  border-radius: 4px;
  font-size: 20px;
  color: #000000;
  box-sizing: border-box;
  font-weight: normal;
}
</style>